var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Properties',{attrs:{"location":_vm.location,"model":_vm.model,"subModel":_vm.subModel,"locationProperties":_vm.locationProperties != null ? _vm.locationProperties.filter(_vm.selectViewLocation) : null,"propertyIcons":_vm.propertyIcons,"showIconMenu":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }